/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const VerificationMethodMultikeyType: core.serialization.Schema<
    serializers.VerificationMethodMultikeyType.Raw,
    Truvity.VerificationMethodMultikeyType
> = core.serialization.enum_(['Multikey', 'EcdsaSecp256k1VerificationKey2019']);

export declare namespace VerificationMethodMultikeyType {
    export type Raw = 'Multikey' | 'EcdsaSecp256k1VerificationKey2019';
}
